<template lang="pug">
  vSelect.organization-select(:value="selectedOption" :options="options" label="name" @input="onInput" :placeholder="loading ? 'Loading...' : 'Select An Organization'" :disabled="loading")
</template>

<script>
import vSelect from 'vue-select'
import Security from '@/service/apis/Security'

export default {
  props: {
    value: {
      type: Number,
      required: false
    }
  },
  created() {
    this.loading = true
    Security.listOrganizations()
      .then((resp) => {
        this.options = resp.data.organizations.organization
        this.updateSelectedOption()
      })
      .catch((e) => { this.$emit('error', e) })
      .then(() => { this.loading = false })
  },
  data: () => ({
    options: [],
    selectedOption: null,
    loading: false
  }),
  methods: {
    updateSelectedOption() {
      if (this.value) {
        this.selectedOption = this.options.find((o) => o.id === this.value)
      } else {
        this.selectedOption = null
      }
    },
    onInput(val) {
      this.$emit('input', val ? val.id : null)
    },
    getSelectedOrganization() {
      return this.selectedOption
    }
  },
  watch: {
    value() {
      this.updateSelectedOption()
    }
  },
  components: {
    vSelect
  }
}

</script>



// WEBPACK FOOTER //
// src/components/ssp/OrganizationSelect.vue